module.exports = __webpack_public_path__ + "caf33e845b553ccda0954c0d0f7e8084.pdf";